import { Step } from 'react-joyride';

import { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';

// import { CompanyServices } from 'api/src';
import { API_Services } from 'src/services/api';

export interface Props {
  api: API_Services;
  isFullWidth?: boolean;
  handleShowTour?: (show: boolean) => void;
  handleTourActive?: (run: boolean) => void;
  setSteps?: (steps: Step[]) => void;
  showTour?: boolean;
}

export interface AppBarProps extends MuiAppBarProps {
  open: boolean;
}

export enum TEST_IDS {
  skeleton = 'skeleton'
}
